
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'

export default {
    components: {
        TitleBox
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            checkPayPass: 'user/checkPayPass',
            userAccountAlipay: 'user/userAccountAlipay'
        })
    },
    data() {
        const validatePass = (rule, value, callback) => {
            if (value === '' || value === null) {
                callback(new Error('请再次输入支付宝账户'))
            } else if (value !== this.ruleForm.alipayAccount) {
                callback(new Error('两次输入支付宝账户不一致!'))
            } else {
                callback()
            }
        }
        return {
            ruleForm: {
                alipayAccount: null, //支付宝or银行卡账号
                alipayReAccount: null, // 二次输入支付宝账号
                bankName: null, // 银行名称
                bindingAccountType: 1 // 1代表支付宝 3代表银行卡
            },
            rules: {
                alipayAccount: [{ required: true, message: '请输入支付宝账户', trigger: 'blur' }],
                alipayReAccount: [{ required: true, validator: validatePass, trigger: 'blur' }]
            },
            rulesPay: {
                alipayAccount: [{ required: true, message: '请输入银行卡账户', trigger: 'blur' }],
                bankName: [{ required: true, message: '请输入银行名称', trigger: 'blur' }]
            },
            loading: false,
            changeSate: true
        }
    },
    methods: {
        async isRealName() {
            // 先判断有没有实名
            if (!this.userinfo.isRealName) {
                this.$message.info('完成实名认证后再进行添加账户')
                this.$router.push('/account/authHome')
                return
            }
            // 然后判断有没有设置支付密码
            if (!this.checkPayPass) {
                this.$message.warning('请设置支付密码')
                this.$router.push('/account/setPayPassword')
                return
            }
            // 如果已经绑定了提现账户
            if (this.userAccountAlipay) {
                this.back()
            }
        },
        back() {
            this.$router.go(-1)
        },
        submitForm() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    let p = {
                        action: {
                            alipayAccount: this.ruleForm.alipayAccount,
                            bankName: this.ruleForm.bankName, // 银行名称
                            bindingAccountType: this.ruleForm.bindingAccountType // 1代表支付宝 3代表银行卡
                        }
                    }
                    this.$api.bindAlipay(p).then((res) => {
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        this.$message.success(res.info)
                        this.$router.go(-1)
                    })
                }
            })
        },
        // 支付宝银行卡切换
        changeSateClick() {
            if (this.changeSate) {
                this.changeSate = false
                this.ruleForm.bindingAccountType = 3
            } else {
                this.changeSate = true
                this.ruleForm.bindingAccountType = 1
            }
            this.$nextTick(() => {
                this.resetForm('ruleForm')
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        }
    },
    mounted() {
        this.$store.dispatch('user/UserCheckAccountWhetherSetPayPass')
        this.$store.dispatch('user/UserAccountAlipay')
        this.$store.dispatch('user/UserGetInfo')
        this.isRealName()
    }
}
